<template>
<v-card class='elevation-0' >
  <vuex-loader :request-id='reqId' ></vuex-loader>
    <v-card-title class='overline'>
      Are you sure you want to delete this appointment?
    </v-card-title>
    <v-card-text>
      <v-alert
        type='warning' warning
        :value='true' >This will permanently delete this appointment</v-alert>
      <v-list three-line >
        <v-subheader class='overline' >Appointment details:</v-subheader>
        <v-divider></v-divider>
        <appointment-list-item :with-action='false' :appointment='appointment' ></appointment-list-item>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <vuex-btn
        :is-disabled='!appointment.id'
        :reqId='reqId'
        text='Delete appointment'
        @save='save' ></vuex-btn>
    </v-card-actions>
    <!-- <v-progress-linear
      v-show='cancelRequest && cancelRequest.loading'
      :indeterminate='true' :height='3' ></v-progress-linear> -->
</v-card>
</template>

<script>
import RequestsMixin from '@/mixins/requests'
import AppointmentListItem from '../AppointmentListItem'

export default {
  name: 'DeleteAppointment',
  mixins: [RequestsMixin],
  components: {AppointmentListItem},
  props: {
    appointment: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      reqId: 'deleteappointment-request',
      withCommunication: true
    }
  },
  watch: {
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.$emit('appointmentdeleteled', this.deleteRequest)
        this.getAppointmentsInRange()
        this.$emit('close')
      }
    }
  },
  computed: {
    deleteRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    }
  },
  methods: {
    save () {
      this.$appointmentguru
          .resource('appointment')
          .id(this.reqId)
          .delete(this.appointment.id)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Delete.vue?442c08c3